export const NOTIFICATION_MANAGE_LINKS = Object.freeze({
  admin: Object.freeze({ to: "/admin/system", label: "View health" }),
  parent: Object.freeze({ to: "/parent/inbox", label: "Open inbox" }),
  teacher: Object.freeze({ to: "/teacher/preferences", label: "Manage" }),
});
